import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import type { GetPanelTags, PanelFilter } from './types';

export const GET_PANEL_TAGS = gql`
  query ($filter: PanelBaseFilter) {
    panel(filter: $filter) {
      tagOptions
      resultOptions
      panelFilterSettings {
        filterId
        panelFilterName
        tags
      }
    }
  }
`;

export const useGetPanelTags = (filter: any): GetPanelTags => {
  const { data, loading, error, refetch } = useQuery(GET_PANEL_TAGS, {
    variables: { filter },
    fetchPolicy: 'network-only',
  });

  const panelTags: string[] = data?.panel?.tagOptions ?? [];
  const panelResultOptions: string[] = data?.panel?.resultOptions ?? [];
  const panelFilterSettings: PanelFilter[] =
    data?.panel?.panelFilterSettings ?? [];

  return {
    panelTags,
    panelResultOptions,
    panelFilterSettings,
    loading,
    error,
    refetch,
  };
};
